import { render, staticRenderFns } from "./remote_diagnosis.vue?vue&type=template&id=20626480&scoped=true"
import script from "./remote_diagnosis.vue?vue&type=script&lang=js"
export * from "./remote_diagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20626480",
  null
  
)

export default component.exports